import React from "react";
import { Field, ErrorMessage } from "formik";
import { Link } from "react-router-dom";

const TermsField = ({ handleBlur, setFieldValue, values }) => (
  <div className="row mt-3">
    <div className="col-12">
      <div className="custom-control custom-checkbox">
        <Field
          type="checkbox"
          className="custom-control-input"
          name="shortTerms"
          id="agree"
          checked={values.shortTerms}
          onChange={(e) => setFieldValue("shortTerms", e.target.checked)}
          onBlur={handleBlur}
        />
        <label htmlFor="agree" className="custom-control-label">
          I have read and agree to the{" "}
          <Link
            className="text-danger"
            onClick={() => {
              window.open("/termsOfuse", "_blank");
            }}
          >
            {" "}
            Terms of Use{" "}
          </Link>{" "}
          and
          <Link
            className="text-danger"
            onClick={() => {
              window.open("/privacyPolicy", "_blank");
            }}
          >
            {" "}
            Privacy Policy{" "}
          </Link>{" "}
          , and I confirm that all data provided is correct.{" "}
        </label>
      </div>
      <ErrorMessage
        name="shortTerms"
        component="div"
        className="invalid-feedback"
      />
    </div>
  </div>
);

export default TermsField;
